<sl-title title="{{ title }}" hidePendo="true"></sl-title>
<ng-container *ngIf="hasActionCards; else noActions">
	<div class="action-list-content">
		<sb-quick-action-list [cards]="actionCards"></sb-quick-action-list>
	</div>
</ng-container>
<ng-template #noActions>
	<!-- The landing page component requires 'sa', not 'lsb' -->
	<sb-landing-page-static module="sa"></sb-landing-page-static>
</ng-template>
<sb-copyright></sb-copyright>
